/** Data layer for masterclass comments (table: masterclass_comments). */
import { supabase } from "../../supabaseClient";
import { fetchDisplayProfiles } from "../utils/profileDisplay";

export async function getMyUserId() {
  const { data } = await supabase.auth.getUser();
  return data?.user?.id || null;
}

const COLS = "id, module_key, author_id, content, created_at";

export async function fetchComments(moduleKey) {
  const { data, error } = await supabase
    .from("masterclass_comments")
    .select(COLS)
    .eq("module_key", moduleKey)
    .is("deleted_at", null)
    .order("created_at", { ascending: true });
  if (error) throw error;
  const comments = data || [];
  const ids = [...new Set(comments.map((c) => c.author_id))];
  // Not a direct profiles select: RLS returns only the viewer's own row,
  // which is why every other commenter read "Coach".
  const profiles = await fetchDisplayProfiles(ids);
  return comments.map((c) => ({ ...c, author: profiles[c.author_id] || null }));
}

export async function postComment(moduleKey, content) {
  const userId = await getMyUserId();
  const { data, error } = await supabase
    .from("masterclass_comments")
    .insert({ module_key: moduleKey, author_id: userId, content })
    .select(COLS)
    .single();
  if (error) throw error;
  return data;
}

export async function deleteComment(id) {
  const { error } = await supabase
    .from("masterclass_comments")
    .update({ deleted_at: new Date().toISOString() })
    .eq("id", id);
  if (error) throw error;
}

export function commentAuthorName(author) {
  if (!author) return "Coach";
  const full = [author.first_name, author.last_name].filter(Boolean).join(" ").trim();
  return full || (author.handle ? `@${author.handle}` : "Coach");
}
export function commentInitials(author) {
  const n = commentAuthorName(author);
  return n.split(" ").map((s) => s[0]).filter(Boolean).slice(0, 2).join("").toUpperCase() || "C";
}
